<script setup>
import TableBody from '@/components/shared/table/TableBody.vue'
import TableRow from '@/components/shared/table/TableRow.vue'

//Emits and props
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  testId: {
    type: String,
    default: 'overviewTable',
  },
  caption: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <TableBody :test-id="testId">
    <caption
      v-if="caption"
      sr-only
    >
      {{ caption }}
    </caption>
    <thead v-if="$slots.headerRow && items.length > 0">
      <TableRow is-header>
        <slot name="headerRow" />
      </TableRow>
    </thead>
    <tbody>
      <TableRow
        v-for="(item, index) in items"
        :key="item.id || index"
      >
        <template #default="{hover}">
          <slot
            name="row"
            :item="item"
            :hover="hover"
            :index="index"
          />
        </template>
      </TableRow>
    </tbody>
  </TableBody>
</template>

<style module lang="scss">
.icon {
  flex: 0 0 2.5rem;
  min-width: 2.5rem;
  display: flex;
  justify-content: center;
}
</style>
